/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerExportToExcelQueryResponse, ApplicationsControllerExportToExcelPathParams } from "../../models/checklistsController/ApplicationsControllerExportToExcel";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { applicationsControllerExportToExcel } from "../../clients/checklistsService/applicationsControllerExportToExcel";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const applicationsControllerExportToExcelQueryKey = (id: ApplicationsControllerExportToExcelPathParams["id"]) => [{
  url: '/api/v1/checklist-applications/:id/excel',
  params: {
    id: id
  }
}] as const;
export type ApplicationsControllerExportToExcelQueryKey = ReturnType<typeof applicationsControllerExportToExcelQueryKey>;
export function applicationsControllerExportToExcelQueryOptions(id: ApplicationsControllerExportToExcelPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = applicationsControllerExportToExcelQueryKey(id);
  return queryOptions<ApplicationsControllerExportToExcelQueryResponse, ResponseErrorConfig<Error>, ApplicationsControllerExportToExcelQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return applicationsControllerExportToExcel(id, config);
    }
  });
}

/**
 * @description Generates an Excel file containing the checklist application with all questions, answers, sources, and nested questions. Supports Unicode characters (including emojis) in filenames via RFC 5987 encoding.
 * @summary Export checklist application to Excel
 * {@link /api/v1/checklist-applications/:id/excel}
 */
export function useApplicationsControllerExportToExcel<TData = ApplicationsControllerExportToExcelQueryResponse, TQueryData = ApplicationsControllerExportToExcelQueryResponse, TQueryKey extends QueryKey = ApplicationsControllerExportToExcelQueryKey>(id: ApplicationsControllerExportToExcelPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<ApplicationsControllerExportToExcelQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? applicationsControllerExportToExcelQueryKey(id);
  const query = useQuery({
    ...applicationsControllerExportToExcelQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}